
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Add error handling for top level errors
const renderApp = () => {
  try {
    const root = document.getElementById("root");
    if (!root) {
      console.error("Root element not found");
      document.body.innerHTML = `
        <div style="display: flex; height: 100vh; align-items: center; justify-content: center; flex-direction: column; font-family: system-ui, sans-serif;">
          <h1 style="color: #004161; margin-bottom: 1rem;">Root Element Not Found</h1>
          <p style="margin-bottom: 2rem;">The application could not start because the root element was not found.</p>
          <button onclick="window.location.reload()" 
            style="background-color: #004161; color: white; padding: 0.5rem 1rem; border-radius: 0.25rem; border: none; cursor: pointer;">
            Refresh
          </button>
        </div>
      `;
      return;
    }
    
    createRoot(root).render(<App />);
  } catch (error) {
    console.error("Failed to render app:", error);
    
    // Create a fallback UI if there's a critical error
    const rootElement = document.getElementById("root");
    if (rootElement) {
      rootElement.innerHTML = `
        <div style="display: flex; height: 100vh; width: 100vw; align-items: center; justify-content: center; flex-direction: column; font-family: system-ui, sans-serif;">
          <h1 style="color: #004161; margin-bottom: 1rem;">Something went wrong</h1>
          <p style="margin-bottom: 2rem;">Please try refreshing the page.</p>
          <pre style="max-width: 800px; overflow-auto; background: #f5f5f5; padding: 1rem; border-radius: 0.25rem; margin-bottom: 2rem; font-size: 12px;">
            ${error instanceof Error ? error.message : 'Unknown error'}
          </pre>
          <button onclick="window.location.reload()" 
            style="background-color: #004161; color: white; padding: 0.5rem 1rem; border-radius: 0.25rem; border: none; cursor: pointer;">
            Refresh
          </button>
        </div>
      `;
    }
  }
};

// Add global unhandled error tracking
window.addEventListener('error', (event) => {
  console.error('Global error handler caught:', event.error);
});

// Add promise rejection tracking
window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled Promise rejection:', event.reason);
});

renderApp();
